import React, { Component } from "react";
import CustomBoardRenewal from "../../components/CustomBoardRenewal";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import CustomText, {
  getFontSize,
  getFontWeight,
} from "../../components/CustomText";
import Color from "../../../utils/Color";
import Grid from "@material-ui/core/Grid";
import CustomTextInput from "../../components/CustomTextInput";
import CustomButton from "../../components/CustomButton";
import _ from "lodash";
import AuthManager from "../../../utils/AuthManager";
import Image from "../../../assets";
import { Helmet } from "react-helmet";
import ReactGA from "react-ga";
import * as selector from "../../../common/selectors";
import * as onlineRenewalSelector from "../../../common/selectors/onlineRenewal";
import * as renewalAction from "../../../common/actions/onlineRenewal";
import { connect } from "react-redux";
import LoadingOverlay from "../../components/LoadingOverlay";
import Box from "@material-ui/core/Box";
import ShowMoreText from "react-show-more-text";
import * as authAction from "../../../common/actions/auth";
class OnlineRenewal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      height: 0,
      width: 0,
      policyNo: "",
      isOnClickNext: false,
      localMaintainMsg: [],
      isExpandMaintain: false,
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  padTo2Digits(num) {
    return num.toString().padStart(2, "0");
  }

  formatDate(date) {
    return (
      [
        date.getFullYear(),
        this.padTo2Digits(date.getMonth() + 1),
        this.padTo2Digits(date.getDate()),
      ].join("-") +
      "T" +
      [
        this.padTo2Digits(date.getHours()),
        this.padTo2Digits(date.getMinutes()),
        this.padTo2Digits(date.getSeconds()),
      ].join(":")
    );
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.props.getMaintenanceMsg();
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    document.cookie.split(";").forEach(function (c) {
      document.cookie = c
        .replace(/^ +/, "")
        .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });
    window.localStorage.removeItem("MyToken");
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  componentDidUpdate = (prevProps) => {
    const {
      checkRenewabilityData,
      checkRenewabilityLoading,
      checkRenewabilityStatus,
      renewalPayNowData,
    } = this.props;

    if (
      this.state.checkRenewabilityAction === true &&
      checkRenewabilityData !== null &&
      checkRenewabilityLoading === false &&
      checkRenewabilityStatus === true
    ) {
      const renewable = onlineRenewalSelector.checkRenewabilityDataRenewable(
        checkRenewabilityData
      );
      const failedStatus = onlineRenewalSelector.checkRenewabilityDataRenewabilityStatus(
        checkRenewabilityData
      );
      const isTiqHome = onlineRenewalSelector.checkRenewabilityDataIsTiqHome(
        checkRenewabilityData
      );
      const redirectUrl = onlineRenewalSelector.checkRenewabilityDataRedirectUrl(
        checkRenewabilityData
      );

      //console.log("failedStatus", failedStatus);
      console.log("renewable", renewable);
      const { history } = this.props;
      if (renewable === true) {
        history.push("/PolicyInfo");
      } else {
        if (failedStatus === 4) {
          if (redirectUrl !== null) {
            this.onClickRepurchase();
          } else {
            history.push("/RenewalUnsuccessful");
          }
        } else {
          history.push("/RenewalUnsuccessful");
        }
      }
      this.setState({ checkRenewabilityAction: false });
    }

    if (prevProps.getMaintenanceMsgData !== this.props.getMaintenanceMsgData) {
      this.props.getMaintenanceMsgData.length > 0 && this.props.getMaintenanceMsgData.map((item, index) => {
        // if (
        //   new Date(this.formatDate(new Date())) >=
        //   new Date(item.Effective_Date) &&
        //   new Date(this.formatDate(new Date())) < new Date(item.End_Date)
        // ) {
        // }
      });
      this.setState({ localMaintainMsg: this.props.getMaintenanceMsgData?.MaintenanceMessage });
    }
  };

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  onChangePolicyNo = (event) => {
    this.setState({ policyNo: event.target.value });
  };

  onClickNext = () => {
    const { history } = this.props;
    const { policyNo } = this.state;
    this.setState({ isOnClickNext: true });
    ReactGA.event({
      category: "RenewalPages",
      action: "Check Policy Number Renewability",
      label: "Check Policy Number Renewability",
      nonInteraction: false,
    });
    if (!this.validateTextInput()) {
      this.onClickCheck();
    }
  };

  onClickReEnter = () => {
    ReactGA.event({
      category: "RenewalPages",
      action: "Re Enter Policy Number",
    });
    const { history } = this.props;
    history.push("/OnlineRenewal");
  };

  onClickCheck = () => {
    ReactGA.event({
      category: "RenewalPages",
      action: "Confirm & Check Renewability",
    });
    const { history, checkRenewability, renewalPayNow } = this.props;
    let Renewal = {
      Renewal: {
        PolicyNumber: this.state.policyNo,
      },
    };

    checkRenewability(Renewal);
    //renewalPayNow("$150.00", "TC0008340", "S0178141C", "PA000363", false);
    this.setState({ checkRenewabilityAction: true });
    //history.push("/PolicyInfo");
    // history.push("/RenewalUnsuccessful")
  };

  onClickHere = () => {
    ReactGA.event({
      category: "RenewalPages",
      action: "Back To Login Page",
    });
    window.open(process.env.REACT_APP_LOGIN_BASE_URL);
  };

  validateTextInput = () => {
    const { policyNo } = this.state;
    return _.isEmpty(policyNo);
  };

  onClickBack = () => {
    window.history.back();
  };

  onClickRepurchase = () => {
    ReactGA.event({
      category: "RenewalPages",
      action: "Repurchase",
    });
    const { checkRenewabilityData } = this.props;
    // const tiqHome = onlineRenewalSelector.checkRenewabilityDataTiqHome(
    //   checkRenewabilityData
    // );
    // const tiqHomeUrl = onlineRenewalSelector.checkRenewabilityDataTiqHomeUrl(
    //   checkRenewabilityData
    // );
    const isTiqHome = onlineRenewalSelector.checkRenewabilityDataIsTiqHome(
      checkRenewabilityData
    );
    const redirectUrl = onlineRenewalSelector.checkRenewabilityDataRedirectUrl(
      checkRenewabilityData
    );

    // if (tiqHome !== null && tiqHomeUrl !== null) {
    //   let form = document.createElement("form");
    //   form.setAttribute("method", "post");
    //   form.setAttribute("action", tiqHomeUrl);
    //   let field = [
    //     { name: "PDPADMail", value: tiqHome.PDPADMail },
    //     { name: "PDPAEmail", value: tiqHome.PDPAEmail },
    //     { name: "APIName", value: tiqHome.APIName },
    //     { name: "PDPAPhone", value: tiqHome.PDPAPhone },
    //     { name: "PDPASMS", value: tiqHome.PDPASMS },
    //     {
    //       name: "RenewalStartDate",
    //       value: tiqHome.RenewalStartDate,

    //     },
    //     { name: "dob", value: tiqHome.dob },
    //     { name: "email", value: tiqHome.email },
    //     { name: "hdbRoomType", value: tiqHome.hdbRoomType },
    //     { name: "mailing_block", value: tiqHome.mailing_block },
    //     { name: "mailing_building", value: tiqHome.mailing_building },
    //     { name: "mailing_postal", value: tiqHome.mailing_postal },
    //     { name: "mailing_street", value: tiqHome.mailing_street },
    //     { name: "mailing_unit", value: tiqHome.mailing_unit },
    //     { name: "mobile", value: tiqHome.mobile },
    //     { name: "name", value: tiqHome.name },
    //     { name: "nric", value: tiqHome.nric },
    //     { name: "property_block", value: tiqHome.property_block },
    //     { name: "property_building", value: tiqHome.property_building },
    //     { name: "property_postal", value: tiqHome.property_postal },
    //     { name: "property_street", value: tiqHome.property_street },
    //     { name: "property_unit", value: tiqHome.property_unit },
    //   ];
    //   for (let i = 0; i < field.length; i++) {
    //     let hf = document.createElement("input");
    //     hf.setAttribute("type", "hidden");
    //     hf.setAttribute("name", field[i].name);
    //     hf.setAttribute("value", field[i].value);
    //     form.appendChild(hf);
    //   }
    //   document.body.appendChild(form);
    //   form.submit();
    // }
    // if (isTiqHome === true) {
    //   // const { renewalTiqHome } = this.props;
    //   // let Renewal = {
    //   //   Renewal: {
    //   //     PolicyNumber: this.state.localPolicyNo,
    //   //   },
    //   // };
    //   // renewalTiqHome(Renewal);
    //   window.location.href =
    //     process.env.REACT_APP_BASE_API_URL +
    //     "Payment/RenewalTiqHome?policyNumber=" +
    //     this.state.localPolicyNo;
    // }
    window.location.href = redirectUrl;
  };

  
   onClickHereViewDetails = () => {
    window.open("https://www.etiqa.com.sg/online/quotation/hdb-fire-insurance");
  };

  renderChildren = () => {
    const { classes } = this.props;
    const { policyNo, isOnClickNext } = this.state;
    return (
      <Grid container direction={"column"} spacing={2}>
        {/* <div className={classes.HDBFireNot}>Note: If you are renewing your <span style={{ fontWeight: 'bold' }}>HDB Fire Insurance</span>, please <a href={'https://www.etiqa.com.sg/online/quotation/hdb-fire-insurance'}
          target="blank" style={{ textDecoration: 'underline', color: '#1858b9', cursor: 'pointer' }}>click here</a>.</div> */}
        <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: '#F1F1F180', padding: '30px 30px', borderRadius: '7px', maxHeight: '186px' }}>
          <div style={{ fontSize: '18px', fontWeight: '700', color: '#333333' }}>HDB Fire Insurance Renewal</div>
          <div style={{ fontSize: '14px', color: '#676767', marginTop: '0.5rem' }}><span style={{ fontSize: '14px', color: '#676767', fontWeight: '700' }}>Note:</span> If you have received a renewal notice from HDB, please proceed to renew here.</div>
          <div
            style={{
              fontSize: '14px',
              fontWeight: '500',
              backgroundColor: '#333333',
              color: '#FFFFFF',
              maxWidth: '109px',
              height: '33px',
              display: 'flex',
              alignContent: 'center',
              justifyContent: 'center',
              alignItems: 'center',
              cursor: 'pointer',
              borderRadius: '3px',
              marginTop: '0.9rem'
            }} onClick={this.onClickHereViewDetails}>Renew Now</div>
        </div>
        <Grid item>
          <CustomText
            design={classes.renewNowTextStyle}
            style={{ color: "#2c3034" }}
          >
            General Insurance Renewal
          </CustomText>
        </Grid>

        <CustomText
          design={classes.renewNowTextStyleV3}
        >
          Policy renewal for general insurance including Private Car Insurance, Tiq Home Insurance and others.
        </CustomText>

        <Grid item style={{marginTop:'1rem'}}>
          <CustomTextInput
            title={"Policy Number"}
            textstyle={classes.labelTextInputTextStyle}
            design={classes.textInputContainer}
            fullWidth={true}
            value={policyNo}
            onChange={this.onChangePolicyNo}
            error={this.validateTextInput() && isOnClickNext}
            errorMessage={
              this.validateTextInput() && isOnClickNext
                ? "You must specify a value for this required field."
                : false
            }
          />
        </Grid>

        <Grid item>
          {/* <div style={{ paddingRight: "1em", display: "inline-block" }}>
            <CustomButton
              title={"Back"}
              design={classes.backButton}
              textstyle={classes.backButtonTextStyle}
              onClick={this.onClickBack}
            />
          </div> */}
          <div style={{ display: "inline-block" }}>
            <CustomButton
              title={"Renew Now"}
              design={classes.nextButtonStyle}
              onClick={this.onClickNext}
              id={"clickRenewalButton"}
            />
          </div>
        </Grid>

        <Grid item>
          {/* Have eWallet credits? Login HERE to utilise your credits for your next policy. */}
          <CustomText design={classes.bottomTextStyle} component="div">
          Have eWallet credits? Login&nbsp;
            <CustomText
              display={"inline"}
              design={classes.highLightedTextStyle}
              onClick={this.onClickHere}
            >
              HERE
            </CustomText>{" "}
            to utilise your credits for your next policy.
          </CustomText>
        </Grid>
      </Grid>
    );
  };

  renderMaintenanceChild = () => {
    const { classes } = this.props;

    const { isExpandMaintain } = this.state;
    const onClickExpandMaintenance = () => {
      this.setState({ isExpandMaintain: !isExpandMaintain });
    };

    return (
      <div
        style={{
          flexDirection: "row",
          justifyContent: "center",
          marginBottom: "0%",
          marginTop: "0%",
        }}
      >
        {this.state.localMaintainMsg.length > 0 ? (
          <Box
            sx={{ width: 1 }}
            style={{
              backgroundColor: "#E5E4E2",
              paddingTop: 13,
              paddingLeft: 30,
              paddingRight: 30,
              paddingBottom: 7,
            }}
          >
            <CustomText design={classes.maintainSubStyle}>
              {this.state.localMaintainMsg.length > 0
                ? this.state.localMaintainMsg.map((item, index) => {
                  return new Date(this.formatDate(new Date())) >=
                    new Date(item.Effective_Date) &&
                    new Date(this.formatDate(new Date())) <
                    new Date(item.Expiry_Date) ? (
                    <Grid style={{ marginBottom: "1em" }}>
                      <ShowMoreText
                        lines={3}
                        more={"Show more"}
                        less={"Show less"}
                        onClick={onClickExpandMaintenance}
                        expanded={false}
                        truncatedEndingComponent={"... "}
                      >
                        <CustomText design={classes.maintainSubStyle}>
                          {item.Message}
                        </CustomText>
                      </ShowMoreText>
                    </Grid>
                  ) : (
                    false
                  );
                })
                : false}
            </CustomText>
          </Box>
        ) : (
          false
        )}
      </div>
    );
  };

  render() {
    const { classes, checkRenewabilityLoading } = this.props;
    const { height, width } = this.state;
    return (
      <div className={classes.root}>
        <Helmet>
          <title>Renewal</title>
        </Helmet>
        {/* <div className={classes.headerStyle} style={{display:"inline-block"}}>
          <div  >
            <img src={Image.renewalHeader} style={{height:"42px"}} />
          </div>
          <div style={{textAlign:"center"}}>
            <CustomText design={classes.headerTextStyle}>
              Policy Renewal
            </CustomText>
          </div>
        </div> */}
        <CustomBoardRenewal
          maintenanceChild={this.renderMaintenanceChild()}
          maintainMsg={this.state.localMaintainMsg.length > 0 ? true : false}
          children={this.renderChildren()}
          height={height}
          width={width}
        />
        {checkRenewabilityLoading ? <LoadingOverlay loading={true} /> : false}
      </div>
    );
  }
}

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "white",
  },
  bottomImageStyle: {
    width: 20,
    height: 20,
    marginRight: 10,
    color: Color.primaryTextColor,
  },
  labelTextInputTextStyle: {
    ...getFontWeight("600"),
    ...getFontSize("medium"),
    color: Color.primaryTextColor,
  },
  textInputContainer: {
    height: 40,
    marginTop: 5,
  },
  nextButtonStyle: {
    width: 150,
    marginTop: 10,
    marginBottom: 10,
  },
  nextTextStyle: {
    ...getFontWeight("bold"),
    ...getFontSize("medium"),
  },
  bottomTextStyle: {
    ...getFontSize("small"),
    color: Color.primaryTextColor,
    fontFamily: "Muli",
  },
  highLightedTextStyle: {
    color: "#1858b9",
    fontFamily: "Muli",
    ...getFontSize("small"),
    ...getFontWeight("600"),
    textDecoration: "underline",
    "&:hover": {
      cursor: "pointer",
    },
  },
  renewNowTextStyle: {
    ...getFontWeight("800"),
    fontSize: 28,
    textAlign: "left",
    color: "#2c3034",
    marginBottom: 0,
    marginTop: 15
  },
  renewNowTextStyleV3: {
    color: '#676767',
    fontSize: '14px',
    fontWeight: '400',
    padding: 0,
    paddingLeft:9,
    paddingRight:9,
  },
  errorTextStyle: {
    color: "red",
  },
  backButton: {
    width: 120,
    marginTop: 0,

    borderColor: Color.primaryTextColor,
    backgroundColor: "transparent",
    color: Color.primaryTextColor,
    opacity: 0.6,
    "&:hover": {
      color: "white",
      backgroundColor: Color.blackButtonColor,
    },
    "&:focus": {
      color: "white",
      backgroundColor: Color.blackButtonColor,
      opacity: 1.0,
    },
  },
  backButtonTextStyle: {
    fontFamily: "Muli",
    ...getFontSize("medium"),
    ...getFontWeight("bold"),
  },
  headerStyle: {
    backgroundColor: "#5b5b5b",
  },
  headerTextStyle: {
    color: "white",
    textAlign: "center",
    fontSize: "28px",
  },
  HDBFireNot: {
    border: 'none',
    margin: '0px 10px',
    padding: '4px 0px',
    fontWeight: '500',
    marginBottom: '5%'
  }
});

// export default withStyles(styles, { withTheme: true })(
//   withRouter(OnlineRenewal)
// );

function mapStateToProps(state) {
  return {
    checkRenewabilityData: selector.checkRenewabilityData(state),
    checkRenewabilityLoading: selector.checkRenewabilityLoading(state),
    checkRenewabilityStatus: selector.checkRenewabilityStatus(state),
    renewalPayNowData: selector.renewalPayNowData(state),
    renewalPayNowLoading: selector.renewalPayNowLoading(state),
    renewalPayNowStatus: selector.renewalPayNowStatus(state),
    renewalTiqHomeData: selector.renewalTiqHomeData(state),
    renewalTiqHomeLoading: selector.renewalTiqHomeLoading(state),
    renewalTiqHomeStatus: selector.renewalTiqHomeStatus(state),

    getMaintenanceMsgLoading: selector.getMaintenanceMsgLoading(state),
    getMaintenanceMsgData: selector.getMaintenanceMsgData(state),
    getMaintenanceMsgStatus: selector.getMaintenanceMsgStatus(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    checkRenewability: (submitData) =>
      dispatch(renewalAction.checkRenewability(submitData)),
    renewalPayNow: (premium, orderNo, nric, policyNo, isRecurring) =>
      dispatch(
        renewalAction.renewalPayNow(
          premium,
          orderNo,
          nric,
          policyNo,
          isRecurring
        )
      ),
    renewalTiqHome: (submitData) =>
      dispatch(renewalAction.renewalTiqHome(submitData)),
    getMaintenanceMsg: () => dispatch(authAction.getMaintenanceMsg()),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(withRouter(OnlineRenewal)));
